import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

function FacebookIcon({ size = 18, color = '#1877F2' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

function TikTokIcon({ size = 18, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.79 1.54V6.79a4.85 4.85 0 0 1-1.02-.1z" />
    </svg>
  );
}

function InstagramIcon({ size = 18, color = '#E4405F' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37a4 4 0 1 1-2.63-2.63A4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
    </svg>
  );
}

function YouTubeIcon({ size = 18, color = '#FF0000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M23 12s0-3.5-.44-5.05a2.87 2.87 0 0 0-2-2C18.94 4.5 12 4.5 12 4.5s-6.94 0-8.56.45a2.87 2.87 0 0 0-2 2C1 8.5 1 12 1 12s0 3.5.44 5.05a2.87 2.87 0 0 0 2 2C5.06 19.5 12 19.5 12 19.5s6.94 0 8.56-.45a2.87 2.87 0 0 0 2-2C23 15.5 23 12 23 12z" />
      <polygon points="9.5,15.5 15.5,12 9.5,8.5" fill="white" />
    </svg>
  );
}

export default function TaglineCTA() {
  return (
    <section id="contact-cta" className="py-20 px-6 bg-green-800 text-center relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,.8) 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}
      />
      <div className="max-w-3xl mx-auto relative z-10">
        <p className="font-serif text-3xl md:text-4xl lg:text-5xl italic text-white mb-3">
          "Growing quality. Sustaining the future."
        </p>
        <p className="text-green-400 text-sm tracking-widest uppercase font-medium mb-10">
          Global Exclusive Ariel Farm Ltd
        </p>

        <div className="flex flex-wrap justify-center items-center gap-6 mt-10">

          {/* Email */}
          <a href="mailto:info@geafarm.com" className="flex items-center gap-2 text-green-300 hover:text-white text-sm">
            <Mail size={18} />
            <span>globalexclusivearielfarmltd@gmail.com</span>
          </a>

          {/* Phones */}
          <a href="tel:+2347046781797" className="flex items-center gap-2 text-green-300 text-sm">
            <Phone size={18} />
            <span>+234 704 678 1797</span>
          </a>

          <a href="tel:+2348053584267" className="flex items-center gap-2 text-green-300 text-sm">
            <Phone size={18} />
            <span>+234 805 358 4267</span>
          </a>
{/* 
          <a href="tel:+39389001226" className="flex items-center gap-2 text-green-300 text-sm">
            <Phone size={18} />
            <span>+234 812 345 6789</span>
          </a> */}

          {/* Address */}
          <span className="flex items-center gap-2 text-green-300 text-sm">
            <MapPin size={18} />
            <span>Evbuarhe Community, Off Benin Abraka Road, Edo State</span>
          </span>

          {/* Socials with brand colors */}
          <a href="https://www.facebook.com/share/1EDUnp2mTh/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:brightness-125 transition">
            <FacebookIcon size={18} />
            <span className="text-green-300">GEA Farm</span>
          </a>

          <a href="https://www.tiktok.com/@arielfarmltd?_r=1&_t=ZN-95J59kQq3XC" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:brightness-125 transition">
            <TikTokIcon size={18} />
            <span className="text-green-300">@geafarm</span>
          </a>

          <a href="https://www.instagram.com/arielfarmltd?utm_source=qr&igsh=cWVjZWVxc29xZnlv" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:brightness-125 transition">
            <InstagramIcon size={18} />
            <span className="text-green-300">@geafarm</span>
          </a>

          <a href="https://youtube.com/@globalexclusivearielfarm-s3p?si=MgfpSzYIDHmDETQ8" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm hover:brightness-125 transition">
            <YouTubeIcon size={18} />
            <span className="text-green-300">GEA Farm TV</span>
          </a>

        </div>

        <p className="mt-8 text-xs text-green-600 tracking-widest uppercase">
          Sustainable Agriculture · Modern Greenhouse Farming · Quality Produce
        </p>
      </div>
    </section>
  );
}